var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"de_box"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"tab_lf"},[_c('span',{staticClass:"red-icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),(_vm.info)?_c('div',{staticClass:"con_box",domProps:{"innerHTML":_vm._s(_vm.info)}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-224f80ce","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/detailbox/detailbox.vue
// module id = 483
// module chunks = 13